import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchThreatEvents, updateAlertStatus } from '../../services/api/threatService';

export const loadThreats = createAsyncThunk('threats/load', async () => fetchThreatEvents(100));

export const setAlertStatus = createAsyncThunk('threats/setAlertStatus', async ({ id, status }) => {
  await updateAlertStatus(id, status);
  return fetchThreatEvents(100);
});

const threatsSlice = createSlice({
  name: 'threats',
  initialState: {
    status: 'idle',
    error: null,
    events: [],
    filters: { severity: 'all', type: 'all', search: '' }
  },
  reducers: {
    setFilter(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadThreats.pending, (state) => { state.status = 'loading'; })
      .addCase(loadThreats.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.events = action.payload;
      })
      .addCase(loadThreats.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(setAlertStatus.fulfilled, (state, action) => {
        state.events = action.payload;
      });
  }
});

export const { setFilter } = threatsSlice.actions;
export default threatsSlice.reducer;

export const selectFilteredThreats = (state) => {
  const { events, filters } = state.threats;
  return events.filter((e) => {
    if (filters.severity !== 'all' && e.severity !== filters.severity) return false;
    if (filters.type !== 'all' && e.type !== filters.type) return false;
    if (filters.search) {
      const q = filters.search.toLowerCase();
      return e.sourceIp.includes(q) || e.target.toLowerCase().includes(q) || e.type.toLowerCase().includes(q);
    }
    return true;
  });
};
